import $ from 'jquery';

const smileyPath = '/bundles/common/images/smiley',
    SmileyService = {};

let smileysList = [
        { value: ':magicien:', img: 'magicien.png' },
        { value: ':diable:',   img: 'diable.png' },
        { value: ':ange:',     img: 'ange.png' },
        { value: ':ninja:',    img: 'ninja.png' },
        { value: '>_<',        img: 'pinch.png' },
        { value: ':pirate:',   img: 'pirate.png' },
        { value: ':zorro:',    img: 'zorro.png' },
        { value: ':honte:',    img: 'rouge.png' },
        { value: ':soleil:',   img: 'soleil.png' },
        { value: ':\'(',        img: 'pleure.png' },
        { value: ':waw:',      img: 'waw.png' },
        { value: ':)',         img: 'smile.png' },
        { value: ':D',         img: 'heureux.png' },
        { value: ';)',         img: 'clin.png' },
        { value: ':p',         img: 'langue.png' },
        { value: ':lol:',      img: 'rire.gif' },
        { value: ':euh:',      img: 'unsure.gif' },
        { value: ':(',         img: 'triste.png' },
        { value: ':o',         img: 'huh.png' },
        { value: ':colere:',   img: 'mechant.png' },
        { value: 'o_O',        img: 'blink.gif' },
        { value: '^^',         img: 'hihi.png' },
        { value: ':-°',        img: 'siffle.png' },
    ],
    smileyToImageMap;

function createRegexp(list) {
    list.forEach(function (smiley) {
        var regEsc = /[-/\\^$*+?.()|[\]{}]/g,
            escapedForElement = gtLtEscape(smiley.value).replace(regEsc, '\\$&'),
            escapedForString = smiley.value.replace(regEsc, '\\$&');

        smiley.regexpElement = new RegExp(escapedForElement, 'g');
        smiley.regexpString = new RegExp(escapedForString, 'g');
    });

    return list;
}

function gtLtEscape(string) {
    string = string.replace(/</g, '&lt;');
    string = string.replace(/>/g, '&gt;');

    return string;
}

function createSmileyToImageHash(list) {
    var hashmap = {};

    list.forEach(function (smiley, n) {
        hashmap[smiley.value] = smileysList[n];
    });

    return hashmap;
}

function createFullImagePath(list) {
    list.forEach(function (smiley, n) {
        list[n].imagePath = getImageSourceForSmiley(smiley.value);
    });
    return list;
}

function getImageSourceForSmiley(smiley) {
    return smileyPath + '/' + smileyToImageMap[smiley].img;
}

function addSmileyToString(string, fromElement) {
    var reg = /(##(\d{1,2})##)/g,
        result;

    smileysList.forEach(function (smiley, n) {
        // alt is index in our smilies table for now
        // avoiding messing things when replacing strings on the first loop
        string = string.replace(fromElement ? smiley.regexpElement : smiley.regexpString, '<img alt="' + ('##' + n + '##') + '" class="smilies js-smiley" src="' + smiley.imagePath + '">');
    });

    // replace img alt by the correct value
    while ((result = reg.exec(string)) !== null) {
        string = string.replace(new RegExp(result[1], 'g'), smileysList[result[2]].value);
    }

    return string;
}

// based on http://benalman.com/projects/jquery-replacetext-plugin/
function addSmileyToElement(elements) {
    $(elements).add('*:not(code,samp,pre,.smilies)', elements).each(function () {
        var node = this.firstChild,
            val,
            newVal,

            // Elements to be removed at the end.
            remove = [];

        // Only continue if firstChild exists.
        if (node) {

            // Loop over all childNodes.
            do {
                // Only process text nodes.
                if (node.nodeType === 3) {

                    // The original node value.
                    val = node.nodeValue;
                    newVal = val;

                    // nodeValue converts htmlentities, let's converts them back to avoid tags madness
                    newVal = gtLtEscape(newVal);

                    newVal = addSmileyToString(newVal, true);

                    // Only replace text if the new value is actually different!
                    if (newVal !== val) {
                        $(node).before(newVal);

                        // Don't remove the node yet, or the loop will lose its place.
                        remove.push(node);

                    }
                }

                node = node.nextSibling;

            } while (node);

        }

        // Time to remove those elements!
        remove.length && $(remove).remove();
    });

    return elements;
}

function revertSmileyFromElement(element) {
    var $element = $(element);

    $element.find('img.js-smiley').each(function (n, image) {
        var $image = $(image),
            smileyValue = $image.attr('alt'),
            txt = document.createTextNode(smileyValue);

        $(txt).insertAfter($image);
        $image.remove();
    });

    return $element;
}

smileyToImageMap = createSmileyToImageHash(smileysList);
smileysList = createRegexp(smileysList);
smileysList = createFullImagePath(smileysList);

SmileyService.getList = function () {
    return smileysList;
};

SmileyService.smilize = function (stringOrElement) {
    if (typeof stringOrElement === 'string') {
        return addSmileyToString(stringOrElement);
    } else {
        return addSmileyToElement(stringOrElement);
    }
};

SmileyService.unsmilize = function (element) {
    if (typeof element === 'string') {
        throw new Error('You must pass an element');
    } else {
        return revertSmileyFromElement(element);
    }
};

SmileyService.isSmiley = function (element) {
    return $(element).hasClass('js-smiley');
};

export default SmileyService;
